import { axios } from "../axios.instance";

export type UnreadMessagesCountRequest = void;

export type UnreadMessagesCountResponse = {
  count: number;
};

export const unreadMessagesCount = async (): Promise<UnreadMessagesCountResponse> => {
  const { data } = await axios.get(`/chats/unread-messages-count`);

  return data;
};
